// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleScreenShareButton_deviceButton__FT9fj","icon":"ToggleScreenShareButton_icon__9Knqj"};